import React from "react";

interface SupportBodyProps {
  supportType: string;
}

const SupportTypeBody: React.FC<SupportBodyProps> = ({ supportType }) => {
  const supportTypeStyles: Record<string, { bg: string; text: string }> = {
    "Ecoute": { bg: "#FFEDEB", text: "#de2e1f" },
    "Prise en main urgente": { bg: "#C7E6FF", text: "#1693f6" },
    "Soutien psychologique": { bg: "#FFF8DD", text: "#eeca34" },
  };

  return (
    <>
        <div className="flex flex-wrap gap-3">
            {supportType.split(",").map((type, index) => {
                const trimmedType = type.trim();
                const style = supportTypeStyles[trimmedType] || {
                    bg: "#e9eee7",
                    text: "#616161",

                };

                return (
                    <div
                        key={index}
                        className="flex items-center justify-center text-center cursor-default rounded-2xl px-2 py-0.5 backdrop-blur-sm hover:bg-blue-100 transition-all duration-200 ease-in-out shadow-sm hover:scale-105"
                        style={{ backgroundColor: style.bg, color: style.text }}
                    >
                        <span 
                            key={index}
                            className="text-xs font-medium justify-center mr-1"
                            
                        >
                            <i
                                className="pi pi-circle-fill mr-2"
                                style={{ fontSize: 6, color: style.text }}
                            />
                            {trimmedType}
                        </span>
                    </div>
                );
            })}
        </div>
    </>
  );
};

export default SupportTypeBody;